<template>
  <div :class="!is_authenticated() ? 'homepage--public' : 'homepage--auth'" class="homepage">
    <div class="homepage--slider">
      <slick :ref="'slick_' + _uid" :options="slick_options">
        <div
          class="homepage--slider--wrapper"
          v-for="(item, index) in slider_items"
          v-bind:key="_uid + index"
        >
          <div
            class="homepage--slider--item"
            :style="'background-image:url(' + item.wallpaper + ')'"
          ></div>
          <div class="homepage--slider--caption">
            <b-container>
              <div class="section--title">
                <h1 class="homepage--slider--caption--title" v-html="item.title"></h1>
                <p
                  v-if="item.text != ''"
                  class="homepage--slider--caption--text"
                  v-html="item.text"
                ></p>
              </div>
            </b-container>
          </div>
        </div>
      </slick>
      <div class="slick-dots--wrapper">
        <b-container class="dots"></b-container>
      </div>
    </div>

    <div class="homepage--content-over-slider">
      <b-container v-if="authentication">
        <booking-engine />
        <div>
          <b-row class="mt-5">
            <b-col md="6">
              <brand
                title="VadoBay live booking"
                href="https://www.vadobay.com/"
                image="assets/brand-modules/bg-vadobay.jpg"
                description="Hai bisogno anche di un hotel? Scopri VadoBay live booking. Cercalo sul tuo portale welfare aziendale"
              >
                <template #overlay-logo>
                  <span v-html="vadobay"></span>
                </template>
              </brand>
            </b-col>
            <b-col md="6">
              <brand
                title="Vacanze by Vadobay"
                href="https://vacanze.vadobay.com/"
                image="assets/brand-modules/bg-vadobay-new.jpg"
                description="I pacchetti vacanza per il welfare aziendale. Prenoti con un click, hai l’assistenza di un’agenzia di viaggi."
              >
                <template #overlay-logo>
                  <span v-html="vadobay"></span>
                </template>
              </brand>
            </b-col>
          </b-row>
        </div>
      </b-container>

      <b-container v-else>
        <div class="bullet mt-5 pt-3">
          <b-row>
            <a
              href="#welfare"
              md="3"
              class="col-sm-6 col-md-3 mt-3 mt-md-0 d-block text-center px-0"
            >
              <div class="bullet--icon" v-html="welfare_credit"></div>
              <p class="bullet--text">
                Credito<br />
                welfare?
              </p>
            </a>
            <a href="#voucher" class="col-sm-6 col-md-3 mt-3 mt-md-0 d-block text-center px-0">
              <div class="bullet--icon" v-html="have_voucher"></div>
              <p class="bullet--text">Hai un buono?</p>
            </a>
            <a href="#form" class="col-sm-6 col-md-3 mt-3 mt-md-0 d-block text-center px-0">
              <div class="bullet--icon" v-html="live_availability"></div>
              <p class="bullet--text">
                Vuoi vedere le<br />
                disponibilità<br />
                live?
              </p>
            </a>
            <a
              href="#contact"
              onClick="window.zE.activate()"
              class="col-sm-6 col-md-3 mt-3 mt-md-0 d-block text-center px-0"
            >
              <div class="bullet--icon" v-html="understand_more"></div>
              <p class="bullet--text">
                Vuoi capirne<br />
                di più?
              </p>
            </a>
          </b-row>
        </div>

        <b-card id="welfare" class="card--welfare border-0" no-body>
          <b-row no-gutters>
            <b-col sm="12" md="6">
              <b-card-body
                class="p-0 pb-3 pb-md-0 pr-md-5"
                title="Prenota un volo col credito welfare"
              >
                <b-card-text>
                  Con
                  <strong>{{ site.payoff }} {{ site.brand }}</strong> prenoti online in tempo reale
                  con il tuo <strong>credito welfare</strong>.<br />
                  Potrai prenotare il tuo viaggio in
                  <strong>pochi click</strong> scegliendo tra le maggiori<br />
                  compagnie aeree, sia di linea che low cost.<br /><br />
                  <strong>1 - Accedi a {{ site.payoff }} dal tuo portale welfare</strong><br />
                  <strong>2 - Cerca e prenota il tuo volo in pochi click</strong><br /><br />
                  Il pagamento avverrà tramite
                  <strong>addebito diretto sul tuo credito welfare</strong>: nessun voucher, nessun
                  codice da creare.<br />
                  Ti serve aiuto con l’utilizzo del credito welfare?
                  <strong>Contatta la nostra assistenza!</strong>
                </b-card-text>
              </b-card-body>
            </b-col>
            <b-col sm="12" md="6">
              <b-card-img
                src="assets/homepage/prenota-con-welfare.png"
                alt="Prenota un volo col credito welfare"
                class="rounded-0"
              ></b-card-img>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="card--voucher border-0 p-4" title="Accedi tramite buono">
          <div id="voucher" class="card--icon" v-html="have_voucher"></div>
          <b-card-text>
            Hai un <strong>buono</strong> da utilizzare su {{ site.payoff }}
            {{ site.brand }}?<br /><br />
            Senza passare dal portale welfare, con il buono puoi accedere direttamente al nostro
            sito!<br />
            Clicca sul bottone qui sotto “Ho un buono” e inserisci il codice che hai ricevuto e i
            tuoi dati personali. In questo modo potrai accedere, effettuare una ricerca e prenotare
            subito il tuo volo!
          </b-card-text>
          <router-link
            class="btn btn-tertiary font-weight-bold col-md-3 text-white"
            :to="{ name: 'dc-sso' }"
            >Ho un buono</router-link
          >
        </b-card>

        <b-card no-body class="card--form border-0 p-0">
          <b-card-body>
            <b-card-title v-if="title_request_form != ''">{{ title_request_form }}</b-card-title>
            <div id="form" class="card--icon" v-html="live_availability"></div>
            <b-card-text v-if="subtitle_request_form != ''">{{
              subtitle_request_form
            }}</b-card-text>

            <form-richiesta-accesso
              :formTitle="title_request_form"
              :formSubTitle="subtitle_request_form"
              :label="'modal-richiesta-accesso'"
              :recipient="config.site.emailSupport"
            />
          </b-card-body>
        </b-card>

        <b-card
          class="card--contact border-0 p-0"
          title="Vuoi capire meglio come utilizzare il tuo credito welfare? Contattaci!"
        >
          <div id="contact" class="card--icon" v-html="understand_more"></div>
          <b-card-text>
            Siamo pronti e disponibili a rispondere ad ogni tuo dubbio, in modo gratuito e
            dedicato.<br />
            Puoi trovarci in webchat, su Whatsapp, per email o al telefono, dal lunedì al venerdì,
            dalle 9 alle 19. Scegli il canale per te!
          </b-card-text>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Slick from 'vue-slick';
import BookingEngine from '@/components/blocks/booking-engine';
import FormRichiestaAccesso from '@/components/blocks/form-richiesta-accesso';
import { is_authenticated } from '@/utilities';
import { vadobay, vivamod, salabam_solutions } from '@/components/svg/logos';
import {
  welfare_credit,
  have_voucher,
  live_availability,
  understand_more,
} from '@/components/svg/common';
import Brand from '../blocks/brand.vue';

export default {
  name: 'homepage',
  components: {
    'booking-engine': BookingEngine,
    slick: Slick,
    'form-richiesta-accesso': FormRichiestaAccesso,
    brand: Brand,
  },
  data() {
    return {
      config: Vue.prototype.$config,
      slider_items: is_authenticated()
        ? Vue.prototype.$config.sliderHome.private
        : Vue.prototype.$config.sliderHome.public,
      slick_options: {
        infinite: true,
        autoplay: 5000,
        autoplaySpeed: 5000,
        speed: 1500,
        fade: true,
        arrows: false,
        dots: true,
        appendDots: '.dots',
      },
      title_request_form: 'Richiedi l’accesso per vedere le disponibilità live',
      subtitle_request_form:
        'Ti invieremo un codice per navigare il sito e cercare il tuo volo. Per prenotare con il credito welfare dovrai comunque fare accesso passando dal tuo portale welfare.',
      site: Vue.prototype.$config.site,
    };
  },
  computed: {
    authentication: {
      get() {
        return this.is_authenticated();
      },
      //set() {}
    },
  },
  created() {
    this.is_authenticated = is_authenticated;
    this.vadobay = vadobay;
    this.vivamod = vivamod;
    this.salabam_solutions = salabam_solutions;
    this.welfare_credit = welfare_credit;
    this.have_voucher = have_voucher;
    this.live_availability = live_availability;
    this.understand_more = understand_more;
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.homepage {
  $this: &;
  position: relative;

  .hero-with-slider {
    position: relative;
    .lf-be {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      /*
            top:60%;
            transform:translateY(-50%);
            */
      bottom: 100px;
    }
  }

  &--banner,
  &--slider {
    width: 100%;
    height: 600px;
    background-size: cover;
    background-position: center center;
    max-height: 50vh;
  }

  &--slider {
    position: relative;
    height: 320px;

    @include media-breakpoint-up(sm) {
      height: 500px;

      @at-root #{$this}--public & {
        height: 300px;
      }
    }

    &--wrapper {
      display: block;
      width: 100%;
      height: 100%;
    }
    &--item {
      display: block;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center center;
    }
    &--caption {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      align-items: center;

      @at-root #{$this}--public & {
        top: auto;
        bottom: 20px;
      }

      @at-root #{$this}--auth & {
        top: 0;
        bottom: 0;
      }

      &--title {
        margin-bottom: 0;
        color: $white;
        margin-left: 0;
        @extend .h1 !optional;
      }

      &--text {
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
        margin-top: 10px;
        margin-left: 0;
      }

      .section--title {
        margin: 0;
        background: rgba($black, 0.5);
        color: $white;
        border-radius: $border-radius-sm;
        border: 0;
        padding: $grid-gutter-width/2 $grid-gutter-width;
        display: inline-block;
      }
    }

    .slick-dots {
      padding: 0;
      width: auto;
      right: $grid-gutter-width/2;

      @at-root #{$this}--public & {
        bottom: 10px;
      }

      @at-root #{$this}--auth & {
        bottom: 150px;
      }

      &--wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        display: none;

        @include media-breakpoint-up(lg) {
          display: block;
        }
      }
      li {
        margin: 0;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      li button {
        padding: 0;
        margin: 0 3px;
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background: $white;
        transition: $transition-base;
        overflow: hidden;
      }
      li.slick-active button {
        width: 10px;
      }
    }

    .dots {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      top: 0;
      margin: auto;
    }
  }

  &--content-over-slider {
    position: relative;
    z-index: 20;

    @at-root #{$this}--auth & {
      margin-top: -70px;

      @include media-breakpoint-up(sm) {
        margin-top: -150px;
      }
    }
  }

  .bullet {
    &--icon {
      display: inline-block;
      background: #0a76bd;
      padding: 25px;
      border-radius: 100px;

      svg {
        $size: 80px;
        width: $size;
        height: $size;
        fill: $white;
      }
    }

    &--text {
      font-weight: bold;
      font-size: 24px;
      margin-top: 10px;
      line-height: normal;
      color: $text;
    }
  }

  .card {
    margin-top: 130px;

    &--voucher {
      background-color: $light-gray-blue;
    }

    &-body {
      position: relative;
    }

    &--icon {
      display: inline-block;
      background: $white;
      padding: 10px;
      border-radius: 100px;
      border: 1px solid $light-gray;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -100%);

      svg {
        $size: 50px;
        width: $size;
        height: $size;
        fill: #0a76bd;
      }
    }

    &-title {
      font-size: 30px;
      font-weight: bold;
    }

    &-text {
      font-size: 16px;
    }
  }
}
</style>
